import { Box, Typography } from '@mui/material'
import AiAskBarRecentDocumentChip from './AiAskBarRecentDocumentChip'
import styles from './index.module.scss'
import { useRecentDocuments } from './useRecentDocuments'

export default function AiAskBarRecentDocuments({ attachments, onAttachDocument }) {
  const recent = useRecentDocuments()

  if (recent.length === 0) return null

  const attachedDocumentIds = new Set(
    attachments.map((entry) => entry.documentId).filter(Boolean),
  )

  return (
    <Box className={styles.recentDocuments}>
      <Typography component="p" className={styles.recentDocumentsHeading}>
        Recent
      </Typography>
      <Box className={styles.recentDocumentsGrid} role="list">
        {recent.map((item) => (
          <Box key={item.id} role="listitem" className={styles.recentDocumentsItem}>
            <AiAskBarRecentDocumentChip
              item={item}
              disabled={attachedDocumentIds.has(item.id)}
              onSelect={() => onAttachDocument(item)}
            />
          </Box>
        ))}
      </Box>
    </Box>
  )
}
